import script from "./ArtistDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtistDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ArtistDetail.vue?vue&type=style&index=0&id=5c2c4d16&lang=scss&scoped=true"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2c4d16"]])

export default __exports__